import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function CardFront() {
  useEffect(() => { document.title = "Affirmation Card Fronts — Printable | Mind Body Spirit HYGIENE™ Tools"; }, []);
  return (
    <div className="bg-gray-100 min-h-screen">
      {/* Screen-only header */}
      <div className="print:hidden fixed top-0 w-full z-50 bg-white/90 backdrop-blur-xl border-b border-[#CCFBF1]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/card-downloads" className="text-[#25a1c2] hover:text-[#068fa2] text-sm font-medium">
            &larr; Back to Card Downloads
          </Link>
          <button onClick={() => window.print()} className="bg-[#25a1c2] hover:bg-[#068fa2] text-white rounded-full px-6 py-2.5 text-sm font-bold">
            Print / Save as PDF
          </button>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 pt-24 pb-16 print:pt-4">
        <div className="print:hidden text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Card Front Design</h1>
          <p className="text-gray-500 text-sm">Right-click the card → "Save Image As" or use Print/Save as PDF. Print multiple copies for your entire deck.</p>
        </div>

        {/* Card grid - 4 per page for printing */}
        <div className="grid grid-cols-2 gap-6 print:gap-4 max-w-2xl mx-auto">
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-2xl print:rounded-xl shadow-xl"
              style={{
                aspectRatio: "3/4",
                background: "linear-gradient(160deg, #042F2E 0%, #068fa2 40%, #25a1c2 100%)",
              }}
            >
              {/* Botanical leaf pattern */}
              <div className="absolute inset-0 opacity-[0.06]" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M40 8 Q46 20 40 32 Q34 20 40 8Z' fill='%23fff' /%3E%3Cpath d='M20 40 Q32 46 20 58 Q8 46 20 40Z' fill='%23fff' /%3E%3Cpath d='M60 40 Q72 46 60 58 Q48 46 60 40Z' fill='%23fff' /%3E%3Cpath d='M40 55 Q46 67 40 79 Q34 67 40 55Z' fill='%23fff' /%3E%3C/svg%3E")`,
                backgroundSize: "80px 80px"
              }} />

              {/* Diamond pattern overlay */}
              <div className="absolute inset-0 opacity-[0.04]" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 0 L40 20 L20 40 L0 20Z' fill='none' stroke='%23fff' stroke-width='0.5' /%3E%3C/svg%3E")`,
                backgroundSize: "40px 40px"
              }} />

              {/* Content */}
              <div className="relative h-full flex flex-col items-center justify-center text-center p-6">
                {/* Decorative top line */}
                <div className="w-12 h-0.5 bg-[#5EEAD4]/30 mb-6" />

                {/* Logo */}
                <img
                  src="/downloads/MBSH-logo-TM-e4476e.png"
                  alt="Mind Body Spirit HYGIENE™ Tools"
                  className="w-20 h-20 md:w-24 md:h-24 rounded-full mb-6 shadow-lg"
                />

                {/* Brand Name */}
                <p className="font-sans text-[#5EEAD4] text-xs tracking-[0.25em] uppercase font-bold mb-2">
                  Mind Body Spirit
                </p>
                <p className="font-sans text-white text-xs tracking-[0.25em] uppercase font-bold mb-6">
                  Hygiene Tools
                </p>

                {/* Decorative divider */}
                <div className="w-8 h-0.5 bg-[#5EEAD4]/30 mb-6" />

                {/* Tagline */}
                <p className="font-serif text-white/80 text-sm italic mb-1">
                  "I Get To"
                </p>

                {/* Website */}
                <p className="font-sans text-[#5EEAD4]/70 text-xs tracking-wider mt-auto">
                  mindbodyspirithygienetools.com
                </p>

                {/* Decorative bottom line */}
                <div className="w-12 h-0.5 bg-[#5EEAD4]/30 mt-4" />
              </div>
            </div>
          ))}
        </div>

        <div className="print:hidden text-center mt-8">
          <p className="text-gray-500 text-sm">Print this page — 8 card fronts per sheet. Cut and pair with your card backs!</p>
        </div>
      </div>
    </div>
  );
}
